import React from 'react';
import Form from 'views/scenes/caregiver_form/Form';

const CaregiverForm = (props) => {
  return (
    <Form {...props} />
  );
};

CaregiverForm.propTypes = {
};

export default React.memo(CaregiverForm);

